import { render } from "./AdminDashboardIndex.vue?vue&type=template&id=2c9c31ea&scoped=true"
import script from "./AdminDashboardIndex.vue?vue&type=script&lang=js"
export * from "./AdminDashboardIndex.vue?vue&type=script&lang=js"

import "./AdminDashboardIndex.vue?vue&type=style&index=0&id=2c9c31ea&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c9c31ea"]])

export default __exports__